<template>
  <section style="padding: 1.5em">
    <div class="row">

      <div class="col-md-12 text-right">
        <button
            class="btn btn-primary mt-4"
            @click="loadModal()"
        >
          Add
        </button>
      </div>
    </div>
<!--    <div v-if="!asyncDone" class="customer-list-info"  >-->
<!--      <div class="loader">-->
<!--      </div>-->
<!--    </div>-->
    <div class="row">
      <div v-for="(row, index) in emailPresets" :key="index" class="col-md-6">
        <div class="accordion mt-3" id="accordionExample">
          <div class="card card-body domain-card">
            <div class="media">
              <button class="btn btn-sm btn-primary mr-4 collapse-btn" data-toggle="collapse" :data-target="'#collapse_'+ index" :aria-controls="'collapseOne_' + index"><i class="fa fa-plus"></i></button>

              <div  class="media-body">
                <div class="domain-head">
                  <h5 class="mt-1 h5-m0">
                    {{ row.title }}
<!--                    <a :href="'https://' + migration.siteDetails.domainName" target="_blank" class="mr-2">{{migration.siteDetails.domainName}}</a><i class="fa fa-copy text-primary mr-2 cursor-pointer" @click="doCopy(migration.siteDetails.domainName)" />-->
<!--                    <small><span class="fs-10 badge mr-2" :class="{'badge-danger' : migration.status === 'pending' || migration.status === 'review' || migration.status === 'abandoned', 'badge-success' : migration.status === 'finished'}">-->
<!--                                         {{(migration.status !== 'finished' && migration.customStatus) ? migration.customStatus : migration.status}}-->
<!--                                         <a href="javascript:void(0)" v-if="migration.status !== 'finished'" @click="changeCustomStatus(migration)" class="fa fa-pencil text-white"></a>-->
<!--                                       </span></small>-->
<!--                    <small><a @click="doCopy(migration.email)" href="javascript:void(0)" class="fs-10 badge badge-info"><i class="fa fa-copy"></i> {{ migration.email }}</a></small>-->
                  </h5>
                </div>
              </div>
            </div>
            <div :id="'collapse_' + index" class="collapse" data-parent="#accordionExample">
              <div v-if="loading" class="card-body">
                <div class="loader"></div>
              </div>
              <div v-else class="card-body">
                <label>Key:</label>
                <input class="form-control" disabled v-model="row.key">
                <label>Message:</label>
                <textarea class="form-control" required rows="3" v-model="row.message"></textarea>
                <button @click="update(row)" class="btn btn-primary mt-4 text-right">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "email",
  data() {
    return {
      emailPresets: [],
      loading: false,
    }
  },
  mounted() {
    this.getPresetsForEmail()
  },
  methods: {
    async update(row){
      try{
        this.loading=true;
        // let id= row.id;
        await db.collection('presets').doc(row.id).update({title: row.title, message: row.message})
        await this.getPresetsForEmail()
        this.loading=false
        swal('Success', 'You have successfully updated email preset', 'success');

      }catch(e){
        this.loading=false
        console.log(e.toString())
        swal('Error', 'Error in updating email preset!', 'error');
      }
    },
    async getPresetsForEmail(){
      this.loading=true
      this.emailPresets=[]
      let ref =await db.collection('presets')
          .where('type', '==', 'email')
          .limit(500).get();
      ref.forEach(el => {
        this.emailPresets.push({id: el.id, ...el.data()})
      })
      console.log('this.emailPresets')
      console.log(this.emailPresets)
      this.loading=false

    },
    loadModal(){
      this.$parent.showModal()
    }
  }
}
</script>

<style scoped lang="scss">
.task-container{
  padding: 1.5em;
}
.cf-status-icons {
  i {
    font-size: 25px;

    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
  }
}
.click-to-copy{
  margin: 0 !important;
  padding: 7px !important;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>
